import styled from 'styled-components'



export const DisplayContainer = styled.div`
padding: 6vh 10vw 15vh;
height: 32vh;
background-color: #282828;


`

export const DisplayItem = styled.div`
margin: 0 auto;
width: 13vw;
height: 13vh;
border-radius: 5px;
display: flex;
justify-content: center;
align-items: center;
background-color: #333;
&:hover{
    background-color: #444;
}

@media screen and (max-width: 768px) {
    width: 60vw;
    height: 10vh;
    margin-bottom: 5vh; 
}
`